/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Video export failed with error: {error}" |
*
* @param {Video_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_failed_toast = /** @type {((inputs: Video_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'exportation video : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Videoexport fehlgeschlagen mit Fehler: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione video non riuscita con errore: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт видео завершился с ошибкой: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`La exportación de video falló con el error: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频导出失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオのエクスポートがエラーで失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो निर्यात त्रुटि ${i?.error} के साथ विफल रहा`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A exportação do vídeo falhou com o erro: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Video export failed with error: ${i?.error}`)
});